module.exports = __webpack_public_path__ + "static/media/box_hero_mobile.0bcd4de2.jpg";